export const paymentType = {
    cashOnDelivery: "CASH_ON_DELIVERY",
    vposInsurance : "VPOS_INSURANCE"
}
